import React from "react";
import { useRoleModel } from "../rolesModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useRoleModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const PageHeaderTitle = <>
    <span style={{ color: "#7F7F7F" }}>{Locale["System Settings"]} </span>
    <span style={{ color: "#000" }}>/ {Locale["Character Settings"]}</span>
</>
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "角色名称",
            placeholder:Locale["Character Name"],
            fieldName: "name"
        },
    ]
    return (
        <YhPageHeader
            title={PageHeaderTitle}
            justify="end"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}